module.exports = __webpack_public_path__ + "static/media/regular_interval.41c20f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/regular_interval.png
// module id = 2634
// module chunks = 0